import './page/llm-provider-list';
import './component/llm-provider-form';

Shopware.Module.register('topdata-llm-connect-llm-provider', {
    type: 'plugin',
    name: 'LLM Providers',
    title: 'TopdataLlmConnectSW6.topdata-llm-connect-llm-provider.title',
    description: 'TopdataLlmConnectSW6.topdata-llm-connect-llm-provider.description',
    color: '#189eff',
    icon: 'default-lock-key',

    routes: {
        list: {
            component: 'topdata-llm-connect-llm-provider-list',
            path: 'list',
            meta: {
                privilege: 'system.plugin_maintenance',
            },
        },
    },

    navigation: [{
        id: 'topdata-llm-connect-llm-provider-list',
        label: 'TopdataLlmConnectSW6.topdata-llm-connect-llm-provider.listTitle',
        color: '#189eff',
        path: 'topdata.llm.connect.llm.provider.list',
        parent: 'topdata-llm-connect',
        position: 10,
    }],
});
